import React from "react";

import { LessonTypePreference } from "@hubcapp/types";
import { useTealium } from "@hubcapp/context";

import { useFormContext } from "react-hook-form/dist/react-hook-form.ie11";
import LessonTypes from "./LessonTypes";

const StateProvider = ({ loading }: { loading: boolean }) => {
  const { watch, setValue } = useFormContext();
  const lessonTypes = watch("lessonTypes");
  const { trackEvent } = useTealium();

  const handleChange = (
    updatedLessonTypes: LessonTypePreference[],
    lessonTypePreference: LessonTypePreference,
  ) => {
    setValue("lessonTypes", updatedLessonTypes);
    trackEvent({
      eventCategory: "Preferences",
      eventAction: "Interaction",
      eventLabel: `${lessonTypePreference.lessonType} - ${
        lessonTypePreference.enabled == true ? "Yes" : "No"
      }`,
    });
  };

  return (
    <LessonTypes
      loading={loading}
      onChange={handleChange}
      lessonTypes={lessonTypes}
    />
  );
};

export default StateProvider;
